// extracted by mini-css-extract-plugin
export var readonly = "_fk-1";
export var star = "_fk-0";